import {
  CreateDocumentBodyDocument,
  CreateDocumentBodyDocumentCategoryEnum,
  DocumentApiInterface as ProDocumentApiInterface,
  Document as ProDocument,
} from "@syadem/kairos-pro-js";
import { DocumentApiInterface as TeamDocumentApiInterface, Document as TeamDocument } from "@syadem/kairos-team-js";
import { AppStore } from "../../store";
import { Service } from "../service";
import { ActionResult } from "../../actionResult";

interface Payload {
  document: {
    name: string;
    category: CreateDocumentBodyDocumentCategoryEnum;
    date?: Date;
  };
  organizationId: string | null;
  teamId: string | null;
  healthRecordId: string;
}

export class CreateDocumentService implements Service<Payload, ProDocument | TeamDocument> {
  constructor(
    private readonly proDocumentApi: ProDocumentApiInterface,
    private readonly teamDocumentApi: TeamDocumentApiInterface,
    private readonly store: AppStore,
  ) {}

  async call({
    document,
    healthRecordId,
    organizationId,
    teamId,
  }: Payload): Promise<ActionResult<ProDocument | TeamDocument>> {
    let apiDocument: ProDocument | TeamDocument;

    if (organizationId && teamId) {
      apiDocument = await this.teamDocumentApi.createDocument(organizationId, teamId, healthRecordId, {
        document: document as CreateDocumentBodyDocument,
      });
    } else {
      apiDocument = await this.proDocumentApi.createDocument(healthRecordId, {
        document: document as CreateDocumentBodyDocument,
      });
    }

    this.addDocumentInStore(healthRecordId, apiDocument);

    return {
      type: "success",
      value: apiDocument,
    };
  }

  private addDocumentInStore(healthRecordId: string, document: ProDocument | TeamDocument) {
    this.store.setState((state) => {
      if (state.healthRecords && state.healthRecords[healthRecordId]) {
        return {
          healthRecords: {
            ...state.healthRecords,
            [healthRecordId]: {
              ...state.healthRecords[healthRecordId],
              documents: [document, ...state.healthRecords[healthRecordId].documents],
            },
          },
        };
      }
      return state;
    });
  }
}
